.accordion-with-image-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 25px;

  > envc-accordion {
    box-sizing: border-box;
    padding: 0;
    display: block;
    width: 100%;
  }

  > envc-accordion-img {
    display: block;
    width: 100%;
  }
}
